﻿import { useEffect } from 'react';

import { useProjectsManager } from 'app/modules/wallforming/components/projects-manager/hooks/useProjectsManager';
import { ProjectsPanel } from 'app/modules/wallforming/components/projects-manager/ProjectsPanel';
import { SaveProjectDialog } from 'app/modules/wallforming/components/projects-manager/SaveProjectDialog';
import { ProjectsDialog } from 'app/modules/wallforming/components/projects-manager/types/projectDialog';
import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';

export const ProjectsManager = () => {
    const {
        isOpen,
        setIsOpen,
        activeDialog,
        setActiveDialog,
        projects,
        isProjectsPending,
        resolvedActiveProject,
        isDirty,
        saveName,
        setSaveName,
        saveDescription,
        setSaveDescription,
        saveError,
        loadCandidate,
        deleteCandidate,
        isSavePending,
        isLoadPending,
        isDeletePending,
        handleSaveProject,
        handleLoadProject,
        handleSaveAndLoadProject,
        handleDeleteProject,
        openLoadDialog,
        openDeleteDialog
    } = useProjectsManager();

    useEffect(() => {
        const handleOnKeyDown = (e: KeyboardEvent) => {
            // Handle shortcut Ctrl+S for saving the project
            if (e.ctrlKey && e.code === 'KeyS') {
                e.preventDefault();
                if (resolvedActiveProject) {
                    window.dispatchEvent(new Event(projectsMenuEvents.triggerSave));
                } else {
                    setActiveDialog(ProjectsDialog.SAVE);
                }
            }
        };
        window.addEventListener('keydown', handleOnKeyDown);
        return () => window.removeEventListener('keydown', handleOnKeyDown);
    }, [resolvedActiveProject, setActiveDialog]);

    return (
        <>
            {isOpen && (
                <ProjectsPanel
                    activeDialog={activeDialog}
                    deleteCandidate={deleteCandidate}
                    isDeletePending={isDeletePending}
                    isDirty={isDirty}
                    isLoadPending={isLoadPending}
                    isProjectsPending={isProjectsPending}
                    isSavePending={isSavePending}
                    loadCandidate={loadCandidate}
                    projects={projects}
                    resolvedActiveProject={resolvedActiveProject}
                    setActiveDialog={setActiveDialog}
                    onClose={() => setIsOpen(false)}
                    onDeleteProject={handleDeleteProject}
                    onLoadProject={handleLoadProject}
                    onOpenDeleteDialog={openDeleteDialog}
                    onOpenLoadDialog={openLoadDialog}
                    onSaveAndLoadProject={handleSaveAndLoadProject}
                />
            )}

            {activeDialog === ProjectsDialog.SAVE && (
                <SaveProjectDialog
                    isPending={isSavePending}
                    saveDescription={saveDescription}
                    saveError={saveError}
                    saveName={saveName}
                    onClose={() => setActiveDialog(ProjectsDialog.NONE)}
                    onDescriptionChange={setSaveDescription}
                    onNameChange={setSaveName}
                    onSave={handleSaveProject}
                />
            )}
        </>
    );
};
